import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { Box } from '@mui/material';
import classnames from 'classnames';

import { ISupplementsNotificationsCardProps } from './SupplementsNotificationsCard.interface';

import './style.scss';

const SupplementsNotificationsCard: FC<ISupplementsNotificationsCardProps> = ({
  className,
  link,
  icon,
}) => {
  const { t } = useTranslation();
  const cardClasses = classnames({ [`${className}`]: !!className }, 'supplements-notifications');

  return (
    <Box className={cardClasses}>
      <Box className="supplements-notifications__icon">
        <Box component="img" src={icon} />
      </Box>
      <Box className="supplements-notifications__section">
        <p className="caption supplements-notifications__text">
          {t('medicationLookup.dietarySupplementEligibilityDescription.0')}{' '}
          <strong>{t('medicationLookup.dietarySupplementEligibilityDescription.1')}</strong>
        </p>
        <p className="caption">
          <NavLink to={link.href}>{t('medicationLookup.dietarySupplementEligibilityLink')}</NavLink>
        </p>
      </Box>
    </Box>
  );
};

export default SupplementsNotificationsCard;
